export default "__VITE_ASSET__3nMDCI28__"